"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Contents = void 0;

var tslib_1 = require("tslib");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var getIconColor = function getIconColor(_a) {
  var isInverse = _a.isInverse,
      pattern = _a.pattern;

  switch (true) {
    case isInverse:
      {
        return 'grey-white';
      }

    case pattern === 'primary':
      {
        return 'blue-500';
      }

    default:
      {
        return 'grey-600';
      }
  }
};

var Contents = function Contents(_a) {
  var label = _a.label,
      leadingIcon = _a.leadingIcon,
      trailingIcon = _a.trailingIcon,
      pattern = _a.pattern,
      scale = _a.scale,
      iconScale = _a.iconScale,
      isInverse = _a.isInverse;
  return react_1.default.createElement(react_1.default.Fragment, null, leadingIcon && react_1.default.createElement(ui_icon_1.Icon, {
    name: leadingIcon,
    title: leadingIcon,
    color: getIconColor({
      isInverse: isInverse,
      pattern: pattern
    }),
    scale: iconScale,
    "aria-hidden": true,
    mr: 1
  }), react_1.default.createElement(ui_text_1.Text, {
    scale: scale
  }, label), trailingIcon && react_1.default.createElement(ui_icon_1.Icon, {
    name: trailingIcon,
    title: trailingIcon,
    color: getIconColor({
      isInverse: isInverse,
      pattern: pattern
    }),
    scale: iconScale,
    "aria-hidden": true,
    ml: 1
  }));
};

var ContentsWithSpace = (0, ui_helper_with_space_1.withSpace)(Contents);
exports.Contents = ContentsWithSpace;